import { render, staticRenderFns } from "./SearchAutocomplete.vue?vue&type=template&id=2fb75b8a&scoped=true"
import script from "./SearchAutocomplete.vue?vue&type=script&lang=js"
export * from "./SearchAutocomplete.vue?vue&type=script&lang=js"
import style0 from "./SearchAutocomplete.vue?vue&type=style&index=0&id=2fb75b8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb75b8a",
  null
  
)

export default component.exports